import React, { createContext, useState, useContext, useCallback } from 'react';

const FilterContext = createContext(null);

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    region: '',
    facility_name: '',
    facility_type: '',
    year:'',
    month_start: 1,
    month_end: 12,
    form_type: '',
    gender: '',
  });

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const updateFilters = useCallback((newFilters) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({
      region: '',
      facility_name: '',
      facility_type: '',
      year:'',
      month_start: 1,
      month_end: 12,
      form_type: '',
      gender: '',
    });
    setDateRange({
      startDate: null,
      endDate: null,
    });
  }, []);

  const getQueryParams = useCallback(() => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        params.append(key, value);
      }
    });

    return params.toString();
  }, [filters]);

  const value = {
    filters,
    dateRange,
    updateFilter,
    updateFilters,
    setDateRange,
    resetFilters,
    getQueryParams,
  };

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};

export const useFilters = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilters must be used within a FilterProvider');
  }
  return context;
};